/* MOG sticky-bar fallback activator (2026-07-26, v2 + chat-bubble lift).
Horizon's sticky-add-to-cart component gated visibility on the mere presence
of Shopify Inbox's <shopify-chat> element (patched in sticky-add-to-cart.js);
this fallback guarantees the bar for real users regardless of the component's
observer state, and lifts the Inbox launcher clear of the bar on mobile.
Idempotent: clears its inline styles on hide so the native component stays in
control whenever it works. */
(function () {
  var bar = null, bb = null, shown = false, t = null;
  function chatEl() { return document.querySelector('shopify-chat'); }
  function chatOpen() {
    var c = chatEl();
    if (!c) return false;
    if (c.hasAttribute('open') || c.classList.contains('open')) return true;
    try { return !!(c.shadowRoot && c.shadowRoot.querySelector('[aria-expanded="true"]')); } catch (e) { return false; }
  }
  function chatLift(on) {
    var c = chatEl();
    if (!c || !c.shadowRoot) return;
    var st = c.shadowRoot.getElementById('mog-chat-lift');
    if (!st) {
      if (!on) return;
      st = document.createElement('style');
      st.id = 'mog-chat-lift';
      st.textContent = 'button{transform:translateY(-66px);transition:transform .25s}';
      c.shadowRoot.appendChild(st);
    }
    st.disabled = !on;
  }
  function update() {
    t = null;
    if (!bar) bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bb) bb = document.querySelector('.buy-buttons-block');
    if (!bar || !bb) return;
    var r = bb.getBoundingClientRect();
    var footer = document.querySelector('footer');
    var nearBottom = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (r.bottom < 0 && !nearBottom && !chatOpen()) {
      if (!shown) {
        shown = true;
        bar.style.setProperty('opacity', '1', 'important');
        bar.style.setProperty('transform', 'translateX(-50%) translateY(0)', 'important');
        chatLift(mobile);
      }
    } else if (shown) {
      shown = false;
      bar.style.removeProperty('opacity');
      bar.style.removeProperty('transform');
      chatLift(false);
    }
  }
  function onScroll() { if (!t) t = setTimeout(update, 120); }
  if (document.querySelector('sticky-add-to-cart')) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }
})();
